import { strings } from 'config';

const numberTranslate = (strNum )=> {
const lang = strings.getLanguage();

    const nums = {
      0: '०',
      1: '१',
      2: '२',
      3: '३',
      4: '४',
      5: '५',
      6: '६',
      7: '७',
      8: '८',
      9: '९'
    };

    if(strNum === 0){
      return lang === 'en' ? 0 : '०';
    }

    if(strNum){

      if(lang === 'en'){
        return strNum;
      } else{
        let arrNumNe =  strNum && strNum
        .toString()
        .trim()
        .split('')
        .map(function(ch) {
          if (ch === '.' || ch === ',' || ch === ':') {
            return ch;
          }
          return nums[Number(ch)];
        });
      return arrNumNe.join('');
      }
    }
  };

  export { numberTranslate };


// WEBPACK FOOTER //
// ./src/utils/numberTranslate.js